/*
 * Copyright (c) 2023-2025 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import { LoadingOutlined } from '@ant-design/icons'
import { CustomOAuthClient } from '@cp/ic-sdk'
import { useNavigate } from '@remix-run/react'
import { Spin } from 'antd'
import { useEffect, useRef } from 'react'
import { PathHelpers } from '~/helpers/PathHelpers'
import { useSdk } from '~/hooks/useSdk'

interface Props {
  code: string
  state: string
  error: string
}

// TODO: refactor to use useEffectOnce.
export function AuthCodeExchanger({ code, error, state }: Props) {
  const { sdk } = useSdk()
  const navigate = useNavigate()
  // This is to prevent double `POST /token` request in local.
  // If we do `POST /token` twice, the second call will be invalid since the code is already exhausted.
  // So, we need to check in the `useEffect` if we have exchanged the code or not -- and skip the process if we already have.
  const isExchangingToken = useRef(false)

  useEffect(() => {
    async function exchangeToken() {
      if (isExchangingToken.current) return
      isExchangingToken.current = true

      // TODO: handle error (e.g. if code is invalid).
      const result = await new CustomOAuthClient(sdk).exchangeAuthorizationCode({ code, error, state })

      if (result?.returnPath) {
        // Navigate to the return path, EXCEPT if the return path is /login (so we don't stuck in a circle).
        navigate(result.returnPath !== PathHelpers.LOGIN ? result.returnPath : '/')
      }
    }

    exchangeToken()
  }, [sdk, navigate, code, error, state])

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <Spin indicator={<LoadingOutlined />} size="large" className="mb-4" />
      <p>Logging in...</p>
    </div>
  )
}
